// extracted by mini-css-extract-plugin
export default {"legendIndicator":"zga-z","legendNew":"Aga-z"};